// The encounter's Terrain tab (`?tab=terrain`, switch `terrain`): reads the record and hands TerrainView the model.
import { useMemo } from 'react';
import { usePatientConditions } from '@/patients/services/use-patient-conditions';
import { buildTerrain, systemForCondition } from './lib/terrain-model';
import { useTerrainReadings } from './services/use-terrain-readings';
import { TerrainView, type TerrainCondition } from './terrain-view';

export function EncounterTerrainTab({ patientId }: { patientId: string }) {
  const { readings, isLoading, isPartial } = useTerrainReadings(patientId);
  const conditionsQuery = usePatientConditions(patientId, 'Active');
  const systems = useMemo(() => buildTerrain(readings), [readings]);
  const conditions = useMemo<TerrainCondition[]>(
    () =>
      (conditionsQuery.data ?? []).flatMap((c) => {
        const label = c.code?.display || c.code?.shortName || c.code?.description || '';
        const system = label || c.code?.code ? systemForCondition(label, c.code?.code) : null;
        // A coded condition with no name still shows, by its code; nothing is shown blank.
        const name = label || c.code?.code || '';
        return system && name ? [{ name, system }] : [];
      }),
    [conditionsQuery.data],
  );
  return <TerrainView systems={systems} conditions={conditions} isLoading={isLoading} isPartial={isPartial || conditionsQuery.isError} />;
}
